import React from 'react';
import StaffLogin from '@/components/StaffLogin';

const KitchenLogin = () => {
  return (
    <StaffLogin
      role="kitchen"
      title="Kitchen Display Login"
      description="Enter your staff password to access the kitchen system"
      redirectTo="/kitchen"
    />
  );
};

export default KitchenLogin;